import createLinks from '@/utils/links/createLinks';
import shouldMaskLinkFromCrawler from '@/utils/links/shouldMaskLinkFromCrawler';
import { generateLinkObject, linkGeneratorHelper } from '@/utils/links/linkGeneratorHelper';

type BreadcrumbItem = {
  text?: string;
  link: string;
  shouldMask?: boolean;
};

type LinkOptions = {
  searchRequestObject: TSearchRequestObject;
};

type Breadcrumbs = {
  items: BreadcrumbItem[];
  resultCount: number;
};

type BreadCrumbInfo = {
  href: string;
  shouldMask: boolean;
};

const generateBreadCrumbInfo = (linkOptions: LinkOptions): BreadCrumbInfo => {
  const linkObject = generateLinkObject(linkOptions);
  const href = createLinks(linkObject);
  const shouldMask = shouldMaskLinkFromCrawler({
    seller: linkObject.seller,
    prioritizedAttributes: linkObject.prioritizedAttributes,
    rangeAttributes: linkObject.rangeAttributes,
  });

  return { href, shouldMask };
};

const formatBreadcrumbs = (
  searchRequestObject: TSearchRequestObject,
  categoriesById: TCategories,
  seller: TSeller,
  totalCount: number,
): Breadcrumbs => {
  const breadcrumbs: Breadcrumbs = {
    items: [],
    resultCount: totalCount,
  };

  if (seller) {
    breadcrumbs.items.push({
      text: seller.title,
      link: linkGeneratorHelper({
        searchRequestObject: {
          seller,
        },
      }),
    });
  }

  const { l1Category, l2Categories } = searchRequestObject.categories;
  if (l1Category) {
    const { href, shouldMask } = generateBreadCrumbInfo({
      searchRequestObject: {
        categories: { l1Category },
        ...(seller && { seller }),
      },
    });
    breadcrumbs.items.push({
      text: categoriesById[l1Category.id].fullName,
      link: href,
      shouldMask,
    });
  }

  if (l2Categories && l2Categories.length > 0) {
    const { href, shouldMask } = generateBreadCrumbInfo({
      searchRequestObject: {
        categories: { l1Category, l2Categories },
        ...(seller && { seller }),
      },
    });
    const text = l2Categories.map((cat) => categoriesById[cat.id].fullName).join(' + ');
    breadcrumbs.items.push({
      text,
      link: href,
      shouldMask,
    });
  }

  return breadcrumbs;
};

export default formatBreadcrumbs;
